export function getWeekNumberText(
  weekNumberStart: number | undefined,
  weekNumberEnd: number | undefined,
): string {
  if (weekNumberStart === undefined || weekNumberEnd === undefined) {
    return "";
  }
  if (weekNumberStart === weekNumberEnd) {
    return `wk ${weekNumberStart}`;
  }
  return `wk ${weekNumberStart}-${weekNumberEnd}`;
}
